module.exports = __webpack_public_path__ + "static/media/ic_black_left_arrow.f722c6cc.svg";